<div class="icon-container">
  <svg class="arrow" width="84" height="24" viewBox="0 0 84 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path id="body" d="M83 12L0.999999 12" stroke="#00A3C7" stroke-width="2" stroke-linecap="round"
      stroke-linejoin="round" />
    <path id="head" d="M7 6L1 12L7 18" stroke="#00A3C7" stroke-width="2" stroke-linecap="round"
      stroke-linejoin="round" />
  </svg>
</div>
